import { render, staticRenderFns } from "./PwdLogin.vue?vue&type=template&id=265118c5&scoped=true"
import script from "./PwdLogin.vue?vue&type=script&lang=js"
export * from "./PwdLogin.vue?vue&type=script&lang=js"
import style0 from "./PwdLogin.vue?vue&type=style&index=0&id=265118c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265118c5",
  null
  
)

export default component.exports